import React, { useState,useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Modal, Button } from 'react-bootstrap';
import { Row, Col, Spinner } from 'react-bootstrap';

import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './styles.css';
import QRCodeGenerator from './QrCodeGenerator';
import { useTranslation } from 'react-i18next';

// Detectar automáticamente si estamos en Electron
const USE_ONLINE = !(typeof window !== 'undefined' && window.electronAPI);
interface PosterProps {
  poster: {
    id: string;
    title: string;
    speakerNamesConcatenated?: string;
    tracks?: string;
    descriptionOnline: number;
    startDateTime:string;
    allAuthorsText:string;
    description:string;
    eposterIdEventFile:string;
    idActivityTrack:number;
    endDateTime:string;
    idActivityType:number;
    activityTypeDescription:string;
    idEventFile:string;
    room:string;
  };
}


//pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
pdfjs.GlobalWorkerOptions.workerSrc = `./pdf.worker.js`;

const Poster: React.FC<PosterProps> = ({ poster }) => 
{
  const { t } = useTranslation();
  const {tracks,room,endDateTime,startDateTime,allAuthorsText,speakerNamesConcatenated,description,activityTypeDescription} = poster;
  const [numPages, setNumPages] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [posterDescription, setPosterDescription] = useState('');
  const [posterDescriptionLoading, setPosterDescriptionLoading] = useState(true);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [filePath,setFilePath] = useState('');

  const hasEposter = !!poster.eposterIdEventFile;
  const hasAbstract = !!poster.idEventFile;
  const canSwap = hasEposter && hasAbstract;

  const [showAbstract, setShowAbstract] = useState(!hasEposter && hasAbstract);
  const handleSwapPDF = () => setShowAbstract(prev => !prev);

  const onDocumentLoadSuccess = ({ numPages }) => setNumPages(numPages);

  const openFullScreen = (e) =>{
    e.stopPropagation();
    setIsFullScreen(true);
  }
  const handleClose = () => {setShowModal(false)};
  const handleOpen = () => {
    setShowModal(true);
    fetchPosterDescription();
  };  
  const fetchPosterDescription = async () => {
    if (poster.descriptionOnline !== 1) {
      setPosterDescription(description);
      setPosterDescriptionLoading(false);
      return;
    }
  
    try {
      setPosterDescriptionLoading(true);
      const res = await fetch(`https://apiv2.kingconf.com/api/sessioncontent/${poster.id}`);
      const data = await res.json();
  
      const desc =
        data.description_ES || data.description_EN || data.description_PT || data.description_FR || data.description || '';
      
      setPosterDescription(desc);
    } catch (err) {
      console.error("Error al cargar descripción:", err);
      setPosterDescription('Descripción no disponible');
    } finally {
      setPosterDescriptionLoading(false);
    }
  };

  const pdfFileId = showAbstract ? poster.idEventFile : poster.eposterIdEventFile;
  const qrUrl = `https://be.kingconf.com/Handlers/EventFileHandler.ashx?AcEventFileId=${pdfFileId}`;

  if (poster.eposterIdEventFile ==  null){
  console.log (pdfFileId)
  console.log(poster.title);
  }
  useEffect(() => {
    if (USE_ONLINE) {
      setFilePath(qrUrl);
    } else {
      if (typeof window !== 'undefined' && window.electronAPI) {
        window.electronAPI.getLocalPath().then((result) => {
          setFilePath(`${result}${pdfFileId}.pdf`);
        }).catch(err => {
          console.error("❌ Error al invocar:", err);
        });
      } else {
        setFilePath(`/pdfs/${pdfFileId}.pdf`);
      }
    }
  }, [pdfFileId]);


  return (
    <>
      {/* CARD */}
      <div className="poster-card" >
        <div>
          {/* TITLE */}
          <h5 style={{ marginBottom: "8px" }}>{poster.title}</h5>
           {/* SPEAKER */}
           {poster.speakerNamesConcatenated && (
            <p style={{ marginBottom: "5px", fontSize: "0.9em", color: "#333" }}>
              <i className="bi bi-person" style={{ marginRight: "6px" }}></i>
              {poster.speakerNamesConcatenated}
            </p>
          )}
          
          {/* TRACK */}
          {poster.tracks && (
            <p style={{ fontSize: "0.9em", color: "#555", margin: 0 }}>
              <i className="bi bi-tag" style={{ marginRight: "6px" }}></i>
              {poster.tracks}
            </p>
          )}

            {/* TYPE */}
            {poster.activityTypeDescription && (
            <p style={{ fontSize: "0.9em", color: "#555", margin: 0 }}>
              <i className="bi bi-bank" style={{ marginRight: "6px" }}></i>
              {poster.activityTypeDescription}
            </p>
          )}


        </div>
        <Button variant="primary" onClick={handleOpen} style={{minWidth: 120}}>  
            <i className="bi bi-eye" style={{ marginRight: "6px" }}></i>{t('view')}</Button>
      </div>

      {/* MODAL */}
      <Modal show={showModal} onHide={handleClose} fullscreen backdrop={true}    keyboard={true}      className="poster-modal-dialog">
      <Modal.Header closeButton className="custom-modal-header">
          <div className="modal-header-flex">
            <div className="spacer"></div>

            <Modal.Title className="modal-title-centered">
              {poster.title}
            </Modal.Title>

            <div className="button-area">
                {canSwap && (
                  <Button variant="primary" onClick={handleSwapPDF} className="show-abstract-button">
                    {showAbstract ? t('viewEPoster') : t('viewAbstract')}
                  </Button>
                )}
            </div>
          </div>
        </Modal.Header>
        <Modal.Body style={{ padding: 0, height: '100vh', overflow: 'auto' }}>
        {!isFullScreen &&
        <>
        <Row className="d-flex">
        

          <Col className="poster_description_wrapper">
                <div className="poster_description_wrapper">
                  {posterDescriptionLoading ? (
                    <Spinner />
                  ) : (
                    <div className="poster-description-content">
                      {room && (
                        <p className="poster-room">
                         <strong>{t('presentation')}:</strong> {room}
                        </p>
                      )}
                      {allAuthorsText && (
                        <p className="poster-time">
                          <i className="bi bi-users" style={{ marginRight: '6px' }}></i>
                          {allAuthorsText}
                        </p>
                      )}
                      {tracks && (
                        <p className="poster-track">
                          <i className="bi bi-tags" style={{ marginRight: '6px' }}></i>
                          {tracks}
                        </p>
                      )}

                    {activityTypeDescription && (
                    <p >
                      <i className="bi bi-bank" style={{ marginRight: "6px" }}></i>
                      {activityTypeDescription}
                    </p>)
                      }
                      <div
                        className="poster-description"
                        dangerouslySetInnerHTML={{ __html: posterDescription }}
                      />
                    </div>
                  )}

            </div>
          </Col>
          <Col className="col-fixed-200">
          <QRCodeGenerator text={qrUrl} variant={showAbstract ? 'abstract' : 'poster'} />
          </Col>
         
        </Row>
              <div className="pdf-container" id={"pdf-container_"+poster.id}  onClick={(e) => {
                                                          e.stopPropagation();
                                                          handleClose();
                                                        }} >
                <div className="maximize-btn-wrapper">
                    <Button
                      variant="outline-secondary"
                      title="Maximizar PDF"
                      onClick={(e) => openFullScreen(e)}
                      className="maximize-btn"
                    >
                      <i className="bi bi-arrows-fullscreen"></i>
                    </Button>
                </div>
            <Document
                file={filePath}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={t('loadingPdf')}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                key={`pdf-document-${poster.id}-${showAbstract ? 'abstract' : 'poster'}`}
              >
             {Array.from(new Array(numPages), (_, index) => (
                <React.Fragment key={`page_${index + 1}`}>
                  <Page
                    pageNumber={index + 1}
                    width={window.innerWidth * 0.9}
                  />
                  <div style={{ height: 20 }}></div>
                </React.Fragment>
              ))}
            </Document>
          </div>
          </>
          }
          {isFullScreen && (
            <div className="fullscreen-pdf-wrapper">
                <Button
                  variant="light"
                  className="exit-fullscreen-btn"
                  onClick={() => setIsFullScreen(false)}
                >
                  <i className="bi bi-x-lg"></i> {t('exitFullscreen')}
                </Button>
                <Document
                  file={filePath}
                  onLoadSuccess={onDocumentLoadSuccess}
                >
                  {Array.from(new Array(numPages), (_, index) => (
                    <Page key={index} pageNumber={index + 1} width={window.innerWidth * 0.95} />
                  ))}
                </Document>
            </div>
          )}

        </Modal.Body>
      </Modal>
    </>
  );
};


export default Poster;
